var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { translate } from '@utils/i18n';
import { patchInspectionSystem } from '../services/AnswersByTypeService';
import { answersByTypeKeys } from './queryKeys';
const namespace = 'features.inspections_answer_by_type';
export function useBulkToggleSubcontractor(inspectionId) {
    const queryClient = useQueryClient();
    const queryKey = answersByTypeKeys.inspection(inspectionId);
    return (rows, on) => __awaiter(this, void 0, void 0, function* () {
        const validRows = rows.filter((r) => r.inspection_system_id != null);
        queryClient.setQueryData(queryKey, (old) => old === null || old === void 0 ? void 0 : old.map((r) => {
            const target = validRows.find((t) => t.inspection_system_id === r.inspection_system_id);
            return target ? Object.assign(Object.assign({}, r), { completed_by_subcontractor: on }) : r;
        }));
        try {
            yield Promise.all(validRows.map((r) => patchInspectionSystem(inspectionId, r.inspection_system_id, on)));
            toast.success(on
                ? translate('bulk_toggle.success_marked', { namespace, count: validRows.length })
                : translate('bulk_toggle.success_restored', { namespace, count: validRows.length }));
        }
        catch (_a) {
            void queryClient.invalidateQueries({ queryKey });
            toast.error(translate('bulk_toggle.error', { namespace }));
            return;
        }
        void queryClient.invalidateQueries({ queryKey });
    });
}
